import api from '../lib/api';
import type { Paginated } from '../types';
import type { Activity, ActivityInput } from '../types/crm';

// Single-record endpoints return `{ data: { id, type, attributes: {...} } }`;
// list endpoints return flat records. See operator.service.ts for the rationale.

export const activityService = {
  getAll: async (params?: Record<string, unknown>): Promise<Paginated<Activity>> => {
    const response = await api.get<Paginated<Activity>>('/activities', { params });
    return response.data;
  },

  getById: async (id: number): Promise<Activity> => {
    const response = await api.get<{ data: { attributes: Activity } }>(`/activities/${id}`);
    return response.data.data.attributes;
  },

  create: async (data: ActivityInput): Promise<Activity> => {
    const response = await api.post<{ data: { attributes: Activity } }>('/activities', { activity: data });
    return response.data.data.attributes;
  },

  update: async (id: number, data: Partial<ActivityInput>): Promise<Activity> => {
    const response = await api.patch<{ data: { attributes: Activity } }>(`/activities/${id}`, { activity: data });
    return response.data.data.attributes;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/activities/${id}`);
  },
};

export default activityService;
